import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { StyledH2 } from './ExtrasOnlyBooking.styles';
import HomogeneousLuggageExtrasSection from './HomogeneousLuggageExtrasSection';
import HeterogeneousLuggageExtrasSection from './HeterogeneousLuggageExtrasSection';

const LuggageExtrasSection = ({ currency, booking, passengers, onStateChange }) => {
  const isHeterogeneousBooking = booking?.isHomogeneous === false;

  return (
    <>
      <StyledH2>
        <FormattedMessage id="addExtras.inventoryControlledExtras" />
      </StyledH2>

      {isHeterogeneousBooking ? (
        <HeterogeneousLuggageExtrasSection currency={currency} booking={booking} passengers={passengers} onStateChange={onStateChange} />
      ) : (
        <HomogeneousLuggageExtrasSection currency={currency} booking={booking} passengers={passengers} onStateChange={onStateChange} />
      )}
    </>
  );
};

LuggageExtrasSection.propTypes = {
  currency: PropTypes.string.isRequired,
  booking: PropTypes.object,
  passengers: PropTypes.array.isRequired,
  onStateChange: PropTypes.func
};

export default LuggageExtrasSection;
